import { Center, Stack } from '@chakra-ui/react'

export function AdminIndexRoute() {
	return (
		<Stack h="100%">
			<Center h="100%">Área Administrativa</Center>
		</Stack>
	)
}
